<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { schema, meetings } from "./data";
import JsonForm from "../../layouts/form";
import Heading from "../../layouts/heading";
import EditorPage from "@/views/layouts/EditorPage";
import DraggableList from "@/components/blocks/DraggableList";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from 'uuid';
import api from "../../../api";

export default {
  props: {
    category: {},
    networkCmsId: null
  },
  page: {
    title: "Member Practices",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, JsonForm,
  Heading, EditorPage, DraggableList
  },
  data() {
    return {
      value: null,
      topics: [],
      categorySelectValue: null,
      currentTopic: null,
      currentTopicData: {},
      currentTopicId: null,
      currentTopicActiveStatus: true,
      totalItem: 0,
      activeItem: 0,
      enabled5: false,
      items: null,
      schema: schema,
      formData: {},
      page: {
        title: "Member Practices",
        lastUpdated: '31 Dec 2020 15:00',
        addNewBtn: true,
        addNewModalTitle: 'Add new Item',
        formData: {},
        schema: {
          name: {
            type: 'text',
            label: 'Name',
            placeholder: 'Enter Name',
            required: true,
            info: false,
            character_count: 50
          },
        },
        deleteBtn: true,
        activeBtn: true,
        submitBtn: false
      }, 
      submitted: false,
      form: {
        message: "",
      }
    };
  },
  methods: {
    selectedTopic(data) {
      this.currentTopicId = data.id
      this.currentTopicData = data
      this.currentTopic = {
        title: data.title,
        date: data.picture,
        website_url: data.additionalProp1.website_url
      }
    },
    async create(val) {
      if(!val) {
        return
      }
      const defaultSlug = val.name.replace(/\s/g, '').toLowerCase();
      var data = {
        uuid: uuidv4(),
        url: this.currentPractice.additionalProp1.url,
        active: true,
        title: val.name,
        picture: '',
        excerpt: 'Text here',
        description: '',
        deleted: false,          
        creationDate: new Date().toISOString(),
        lastModifiedDate: new Date().toISOString(),
        categoryId: this.category.id,
        cmsId: this.networkCmsId,
        additionalProp1: {
          website_url: null,
          slug: defaultSlug,
          categoryName: this.category.name,
        }
      };
      try {
        const response = await api.post('/api/categories/'+this.category.id+'/pages', data)
        this.createSlug(defaultSlug, response.data)
      } catch (error) {
        console.log(error)
      }
    },
    async createSlug(defaultSlug, page) {
      const data = {
        uuid: uuidv4(),
        name: defaultSlug,
        url: this.currentPractice.additionalProp1.url+'/'+defaultSlug,
        path: '/'+defaultSlug,      
        creationDate: new Date().toISOString(),
        lastModifiedDate: new Date().toISOString(),
        pageId: page.id,
        cmsId: this.networkCmsId,
        alertId: '',
        additionalProp1: {}
      };
      try {
        await api.post('/api/pages/'+page.id+'/slug', data)
        this.topics.push(page)
        Swal.fire("Item Added!", "Item Added Successfully!", "success");
      } catch (error) {
        console.log(error)
      }
    },
    async deleted() {
      const params = {
        categoryName: this.category.name,
        slug: this.currentTopicData.additionalProp1.slug       
      };
      try {
        await api.delete('/api/pages/'+this.currentTopicId, { params: params })
        Swal.fire("Topic Deleted!", "Topic Deleted Successfully!", "warning")
        this.topics.splice(this.topics.findIndex((i) => {
          return i.id === this.currentTopicId;
        }), 1)
          this.selectedTopic(this.topics[0])          
      } catch (error) {
        console.log(error)
      }
    },
    async updateSlug(defaultSlug, pageId, page) {
      const data = {
        name: defaultSlug,
        url: this.currentPractice.additionalProp1.url+'/'+defaultSlug,
        path: '/'+defaultSlug,      
      };
      try {
        await api.patch('/api/pages/'+pageId+'/slug', data)
        Swal.fire("Topic Updated!", "Topic/Slug Updated Successfully!", "success");
        page.id = this.currentTopicId;
        this.selectedTopic(page)
        const objIndex = this.topics.findIndex((obj => obj.id === page.id));
        this.topics[objIndex] = this.currentTopicData
      } catch (error) {
        console.log(error)
      }
    },
    async submit() {
      const data = {
        title: this.currentTopic.title,
        url: this.currentTopicData.url,
        description: this.currentTopicData.description,
        active: this.currentTopicActiveStatus,
        picture: this.currentTopic.image,
        additionalProp1: {
          date: this.currentTopic.date,
          website_url: this.currentTopic.website_url,
          slug: this.currentTopic.slug,
          oldSlug: this.currentTopicData.additionalProp1.slug,
          categoryName: this.category.name
        },
      };
      try {
        await api.patch('/api/pages/'+this.currentTopicId, data)
        this.updateSlug(this.currentTopic.slug, this.currentTopicId, data)
      } catch (error) {
        console.log(error);
      }
    },
    activateToggle() {
      this.currentTopicActiveStatus = !this.currentTopicActiveStatus
    },
    async getItem() {
      try {
        if (!this.category) {
          this.items = meetings
          console.log(this.items)
          return
        }
        const { data } = await api.get('/api/categories/'+this.category.id+'/pages')
        this.items = data
      } catch (error) {
        console.log(error)
      }
    },
    getPages() {
      api.get('/api/categories/'+this.category.id+'/pages')
      .then(response => {
        this.topics = response.data
        if(this.topics.length) {
          this.totalItem = this.topics.length
          this.activeItem = this.topics.filter(vid => vid.active).length
          this.selectedTopic(this.topics[0])          
        }
      })
      .catch(e => {
        console.log(e)
      })  
    },
  },
  watch: {
    currentCms() {
      this.$router.push({ name: 'Network' })    
    },
    currentTopic: function (val) {
      if(val != null)
      this.page.deleteBtn = true;
      this.currentTopicActiveStatus = this.currentTopicData.active;
    },
  },
  async mounted() {
    this.getPages();
  }
}
</script>

<template>
  <Layout>
    <Heading :page="page" :activeStatus="currentTopicActiveStatus" @activateToggle="activateToggle"
    @created="create" @deleted="deleted" @form-submitted="submit"></Heading>
    <EditorPage>
      <template v-slot:aside>
        <div class="d-flex mb-2">
          <h5 class="font-size-14 my-2 align-self-sm-center font-theme-black-color">Practice Title</h5>
          <!-- <i class="ri-information-fill my-auto font-size-18 font-gray-color"></i> -->
            <img id="info_tooltip" class="align-self-center mx-2"
              src="@/assets/images/info.svg" alt="">
            <p class="font-size-14 mb-2 mt-2 text-muted ml-auto font-weight-medium">
              <span class="border-right-dark mr-2 pr-1">Total: {{totalItem}} </span>
              <span> Active: {{activeItem}}</span>
            </p>
        </div>
        <draggable-list :items="topics" @click="selectedTopic"></draggable-list>
      </template>
      <template v-slot:editor>
        <JsonForm :page="page" :schema="schema" :formData="currentTopic" v-if="currentTopic"></JsonForm>
        <div class="font-size-14 font-weight-medium d-flex align-items-center justify-content-between mt-4 mb-5 border-right-dark">
          <b-button v-on:click="submit" class="px-4" variant="primary">Save</b-button>
        </div>
      </template>
    </EditorPage>
  </Layout>
</template>
<style scoped>
.border-right-dark {
  border-right: 1px solid #DADCE3;
}

.color-patientblue {
  color: #005EB8;
}
</style>